const MENU = {
  HOME: {
    name: "HOME",
    path: "/",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      title: "SPOTV K",
      // metaTags: [
      //   {
      //     name: "description",
      //     content: "'별의 별 재미'를 전하는 오리지널 엔터테인먼트 채널 STATV"
      //   },
      //   {
      //     name: "og:title",
      //     content: "스타티비｜STATV"
      //   },
      //   {
      //     name: "og:description",
      //     content: "'별의 별 재미'를 전하는 오리지널 엔터테인먼트 채널 STATV"
      //   }
      // ]
    }
  },
  BROADCAST: {
    name: "채널소개",
    path: "/broadcast",
    component: () => import("@/views/broadcast/Broadcast.vue"),
    meta: {
      title: "채널소개｜SPOTV K "
    }
  },
  SCHEDULE: {
    name: "편성표",
    path: "/schedule",
    component: () => import("@/views/schedule/Schedule.vue"),
    meta: {
      title: "편성표｜SPOTV K "
    }
  },
  CHANNEL: {
    name: "채널번호",
    path: "/channel",
    component: () => import("@/views/channel/Channel.vue"),
    meta: {
      title: "채널번호｜SPOTV K "
    }
  },
  NOTICE: {
    name: "공지/이벤트",
    path: "/notice",
    component: () => import("@/views/board/Board.vue"),
    meta: {
      title: "공지/이벤트｜SPOTV K "
    }
  },
};

const SUBMENU = {
  ADVERTISE: {
    path: "/advertise", 
    component: () => import("@/views/support/Advertise.vue"),
    meta: {
      title: "광고문의｜SPOTV K "
    }
  },
  CONTACT: {
    path: "/contact", 
    component: () => import("@/views/support/Contact.vue"),
    meta: {
      title: "사업제휴문의｜SPOTV K "
    }
  },
  LOCATION: { 
    path: "/location", 
    component: () => import("@/views/support/Location.vue"),
    meta: {
      title: "오시는 길｜SPOTV K "
    }
  },
}

export { MENU, SUBMENU }